<!-- <p>visitor-ticket-dialog works!</p> -->

<div class="mat-dialog-header">
  <h1 mat-dialog-title>
    <strong>Create Visitor Tickets</strong>
  </h1>
</div>
<mat-dialog-content class="mat-typography">
  <div class="tickets-dialog-options">
    <form [formGroup]="visitorTicket">
      <mat-form-field appearance="outline">
        <mat-label>Subject</mat-label>
        <mat-select formControlName="ticketSubject">
          <mat-option value="0">Missing Visitor Details</mat-option>
          <mat-option value="1">Scheduling Error</mat-option>
          <mat-option value="2">QR Error</mat-option>
          <mat-option value="3">Other</mat-option>
        </mat-select>
      </mat-form-field>
      <br />
      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          formControlName="ticketDescription"
          cdkTextareaAutosize
          cdkAutosizeMinRows="4"
          cdkAutosizeMaxRows="1"
          matInput
        ></textarea>
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Close</button>
  <button
    [disabled]="visitorTicket.invalid"
    mat-raised-button
    [mat-dialog-close]="visitorTicket.value"
  >
    Submit
  </button>
</mat-dialog-actions>
